define('views/layouts/content/layout-info-overlay',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // views
    'views/layouts/layout-overlay',
    'views/layouts/content/layout-info',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // views
    VLayoutOverlay,
    VLayoutInfo
) {

    /**
     * Provides a panel like overlay which toggles an open class (making it
     * slide) and provides common methods to manage the panel, trigger layout
     * events after its defined transition.
     */
    var VLayoutInfoOverlay = VLayoutOverlay.extend({

        initialize: function(opt) {
            opt = opt || {};
            var view = opt.view = new VLayoutInfo({ view: opt.view });
            VLayoutInfoOverlay.__super__.initialize.apply(this, arguments);
            this.listenTo(view, 'drawer:toggle', this.onDrawerToggle);
        },

        is: function(view) {
            return this.content.getView() === view;
        },

        getView: function() {
            return this.content;
        },

        toggleFull: function(val) {
            LayoutState.setInfoState(null, val);
            this.$el.toggleClass('full', val);
        },

        onDrawerToggle: function(val) {
            if (val) this.toggleFull(val);
        }

    });

    return VLayoutInfoOverlay;
});

